$(document).ready(function () {


    $(".main_category_list").mouseenter(function () {


        var lazyImages = $(this).find("img.lazy-header");


        lazyImages.lazyload({
            effect: "fadeIn",
            placeholder: "/assets/images/placeholder_img/main_menu_placeholder.png"
        });
    });


    $(document).on("click", ".customer-group .my-favorites-container", function () {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'Category': 'Favoriler',
            'Action': 'Click',
            'Label': window.currentPage,
            'noninteraction': true,
            'event': 'gaEvent'
        });

        $(".popup-action-title").removeClass("active-tab");
        $(".register-title").addClass("active-tab");
        Vivense.loginPopup.openFavoritesPopup();
    });

    $('.headerMyFavoriteLink').on('click', function (e){
        Vivense.loginPopup.openFavoritesPopup();
    });

    $('.my-cart-desktop, .my-cart-mobile').on('click',function (e){
        e.preventDefault();     
    
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'Category': 'Sepetim',
            'Action': 'Click',
            'Label': window.currentPage,
            'noninteraction': true,
            'event': 'gaEvent'
        });

        window.location.href = $(this).attr("href");
    });

    $(".toggle_mobile_menu").on("click", function () {
        $(".profile_menu_wrapper").removeClass("open_menu")
        $("body").removeClass("overflow_hidden")

    });

    $(".headerMyAccountMobile").on("click", function () {
        $(".profile_menu_wrapper").addClass("open_menu")
        $("body").addClass("overflow_hidden")
    });

    var jqueryWin = $(window);
    var wrapper = $('.scroll-top-wrapper');

    if (wrapper.length == 0) {
        return;
    }

    var showing = false;
    var cutoff = 500;


    function scrollToTop() {
        var element = $('body');
        var offset = element.offset();
        var offsetTop = offset.top;
        $('html, body').animate({scrollTop: offsetTop}, 500, 'linear');
    }

    function checkScroll() {
        var scrollTop = jqueryWin.scrollTop();

        if (scrollTop > cutoff && !showing) {
            wrapper.addClass('show');
            showing = true;

        } else if (scrollTop <= cutoff && showing) {
            wrapper.removeClass('show');
            showing = false;
        }

    }

    setInterval(checkScroll, 1500);

    wrapper.on('click', scrollToTop);

});

(function ($) {
    $(function () {

        $('.categorie-page-luna-head__title').click(function() {
            $('.categorie-page-luna-head__arrow-icon').toggleClass('active');
            $('.categorie-page-luna-head__content').toggle();
            $('.categorie-page-luna-head__arrow-area').toggle();
        });

        $('.categorie-page-luna-head__arrow-area').click(function(){
            $(this).hide();
            $('.categorie-page-luna-head__arrow-icon').removeClass("active");
            $('.categorie-page-luna-head__content').hide();
        })

    });
})(jQuery);